'use client'

import { useCallback, useRef } from 'react'
import { ANALYTICS_EVENTS } from './events'
import { trackSiteEvent } from './site-event'

/** Which marketing demo the visitor operated — the `demo` value of `product_demo_started`. */
export type ProductDemo = 'subtitle' | 'meeting_editor' | 'meeting_outputs'

/**
 * Returns a function to call from every handler where the visitor operates the
 * demo. The first call per mount — per page view — reports
 * `product_demo_started`; later calls do nothing, so "how many visitors tried
 * it" is not inflated by how long they played with it.
 */
export function useDemoStarted(demo: ProductDemo): () => void {
  const reportedRef = useRef(false)
  return useCallback(() => {
    if (reportedRef.current) return
    reportedRef.current = true
    trackSiteEvent(ANALYTICS_EVENTS.productDemoStarted, { demo })
  }, [demo])
}
